import { useEffect, useState } from 'react';
import api from '../lib/api';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import GroupedProofGallery from '../components/GroupedProofGallery';
import { Images, Loader2 } from 'lucide-react';

const ACTION_OPTS = [
  { v: 'all', l: 'All actions' }, { v: 'install', l: 'Install' }, { v: 'inspect_ok', l: 'Inspection' },
  { v: 'damage', l: 'Damage' }, { v: 'needs_repair', l: 'Needs Repair' }, { v: 'repair', l: 'Repair' }, { v: 'replace', l: 'Replace' },
];

export default function ProofsGallery() {
  const [societies, setSocieties] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [societyId, setSocietyId] = useState('all');
  const [campaignId, setCampaignId] = useState('all');
  const [action, setAction] = useState('all');
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/societies').then((r) => setSocieties(r.data)).catch(() => {});
    api.get('/campaigns').then((r) => setCampaigns(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    setData(null);
    const p = new URLSearchParams({ limit: '1000' });
    if (societyId !== 'all') p.set('society_id', societyId);
    if (campaignId !== 'all') p.set('campaign_id', campaignId);
    if (action !== 'all') p.set('action_type', action);
    api.get(`/proofs?${p.toString()}`).then((r) => setData(r.data));
  }, [societyId, campaignId, action]);

  return (
    <div className="space-y-5">
      <div><p className="overline text-primary flex items-center gap-2"><Images className="h-3.5 w-3.5" /> All-over Proof Feed</p><h1 className="font-head text-3xl font-bold">Proof Gallery</h1></div>

      <div className="flex flex-wrap items-center gap-2">
        <Select value={societyId} onValueChange={setSocietyId}>
          <SelectTrigger data-testid="pg-society" className="w-44 bg-card"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">All societies</SelectItem>{societies.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={campaignId} onValueChange={setCampaignId}>
          <SelectTrigger data-testid="pg-campaign" className="w-44 bg-card"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">All campaigns</SelectItem>{campaigns.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={action} onValueChange={setAction}>
          <SelectTrigger data-testid="pg-action" className="w-40 bg-card"><SelectValue /></SelectTrigger>
          <SelectContent>{ACTION_OPTS.map((a) => <SelectItem key={a.v} value={a.v}>{a.l}</SelectItem>)}</SelectContent>
        </Select>
      </div>

      {!data ? <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
        : <GroupedProofGallery proofs={data.proofs} allowedGroupings={['society', 'client', 'campaign', 'lift', 'site_type', 'inspection', 'action', 'operator']} initialGroupBy="society" emptyMessage="No proof photos match these filters yet." />}
    </div>
  );
}
